<mat-card class="class-booking-config-card">
  <mat-toolbar class="toolbar-subtitle">
    <mat-toolbar-row>Access Configuration per Studio</mat-toolbar-row>
  </mat-toolbar>
  <mat-card-content class="class-booking-content">
    @if (classBookingConfig.enabled) {
      <mat-checkbox
        class="class-booking-checkbox"
        [ngModel]="classBookingConfig.bookingRequiredForCheckin ?? false"
        (ngModelChange)="classBookingConfig.bookingRequiredForCheckin = $event">
        <b>In-app booking required for every check-in</b>
      </mat-checkbox>
      <span class="class-booking-content-paragraph">
        When checked, the QR-code or MMS check-ins will only work if the user has
        a valid booking at the studio. Check-in will be allowed starting from 1
        hour before the session until 30 minutes after the end of the session.
      </span>
      <mat-divider class="class-booking-content-divider"></mat-divider>
      <mat-form-field class="auto-checkin-field">
        <mat-label>Automatic check-in</mat-label>
        <mat-select
          [ngModel]="classBookingConfig.autoCheckinMode"
          (ngModelChange)="handleOnAutoCheckinModeChange($event)">
          <mat-option [value]="AutoCheckinMode.DISABLED">Disabled</mat-option>
          <mat-option [value]="AutoCheckinMode.AT_CLASS_START">
            Automatic check-in
          </mat-option>
          <mat-option [value]="AutoCheckinMode.ON_MMS_ATTENDANCE_CONFIRMED">
            Set attendance based on MMS information
          </mat-option>
        </mat-select>
      </mat-form-field>
      <span class="auto-checkin-content-paragraph">
        Select whether automatic check-in is based on in-app bookings or MMS
        attendance. Leave it disabled to keep automatic check-in turned off. This
        change will affect the attendance mode setting in all provider
        configurations.
      </span>
      <mat-divider class="class-booking-content-divider"></mat-divider>
      <mat-checkbox
        class="checkin-only-checkbox"
        [ngModel]="classBookingConfig.checkinOnlyGym ?? false"
        (ngModelChange)="classBookingConfig.checkinOnlyGym = $event">
        <b>Check-in only gym</b>
      </mat-checkbox>
      <span class="checkin-only-content-paragraph">
        When checked, users will only be able to do check-ins and not book in this
        gym
      </span>
      <mat-divider class="class-booking-content-divider"></mat-divider>
      <mat-checkbox
        class="class-booking-checkbox"
        [ngModel]="classBookingConfig.createMemberAccountForCheckin ?? false"
        (ngModelChange)="handleOnCreateMemberAccountForCheckinChange($event)">
        <b>MMS Member account creation</b>
      </mat-checkbox>
      <span class="class-booking-content-paragraph">
        When checked, the MMS registration will be supported at the check-in time,
        meaning an account will be created for the user on the respective MMS.
      </span>
      <mat-checkbox
        class="class-booking-checkbox"
        [ngModel]="classBookingConfig.hasAccessPass ?? false"
        (ngModelChange)="classBookingConfig.hasAccessPass = $event"
        [disabled]="!classBookingConfig.createMemberAccountForCheckin">
        <b>Access pass creation</b>
      </mat-checkbox>
      <span class="class-booking-content-paragraph">
        When checked, an access pass would be created during the check-in time in
        Barcode, QR Code or NFC format depending on the MMS. In order to use this
        feature the MMS Member account creation option has to be enabled first!
      </span>
      <mat-divider class="class-booking-content-divider"></mat-divider>
    }
    @if (showSkipCheckinRequiredForMmsAccess) {
      <mat-checkbox
        class="class-booking-checkbox"
        [ngModel]="classBookingConfig.skipCheckinRequiredForMmsAccess ?? false"
        (ngModelChange)="classBookingConfig.skipCheckinRequiredForMmsAccess = $event">
        <b>Skip check-in enforcement for MMS access</b>
      </mat-checkbox>
      <span class="class-booking-content-paragraph">
        When checked, members no longer need to check in via the app before
        they can access the gym through MMS (RFID card/band).
      </span>
    }
  </mat-card-content>
</mat-card>
